/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Button_LabelInputs */

const en_tasks_button_label = /** @type {(inputs: Tasks_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks`)
};

const fr_tasks_button_label = /** @type {(inputs: Tasks_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâches`)
};

const ms_sg2_tasks_button_label = /** @type {(inputs: Tasks_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugasan`)
};

/**
* | output |
* | --- |
* | "Tasks" |
*
* @param {Tasks_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_button_label = /** @type {((inputs?: Tasks_Button_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Button_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_button_label(inputs)
	if (locale === "fr") return fr_tasks_button_label(inputs)
	return ms_sg2_tasks_button_label(inputs)
});